import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL PARTS
import Logs from 'parts/logs/Logs';

// VARIABLES
const COMMENTS_FETCH_ARGS = {
  endpoints: ENDPOINTS.inventory.comments,
  onSuccess: ({ results }) => results,
  params: inventoryId => ({
    inventoryId
  })
}
const ACTIVITY_FETCH_ARGS = {
  endpoint: ENDPOINTS.inventory.activityLog,
  onSuccess: ({ result: { aryActivityLog } }) => aryActivityLog
}

// COMPONENTS
const InventoryCommentsLog = props => (
  <Logs.Comments
    fetchArgs={COMMENTS_FETCH_ARGS}
    controlNames={{
      body: 'name'
    }}
    formArgs={{
      endpoint: ENDPOINTS.inventory.comments.add,
      params: inventoryId => ({
        inventoryId,
        typeId: 1
      })
    }}
    dataProcessor={({
      name,
      nameFull,
      dateCreated
    }) => ({
      body: name,
      createdBy: nameFull,
      createdDate: dateCreated
    })}
    {...props}
  />
);
const InventoryActivityLog = props => (
  <Logs.Activity
    fetchArgs={ACTIVITY_FETCH_ARGS}
    {...props}
  />
);
InventoryActivityLog.Tab = Logs.Activity.Tab;

// MAIN COMPONENT
const InventoryLogs = () => (
  <Logs
    logs={{
      sales: Logs.Sales,
      comments: InventoryCommentsLog,
      activity: InventoryActivityLog
    }}
  />
);

// EXPORT
export default InventoryLogs;
